export const CARD = 'CARD';
export const ACH = 'ACH';
export const BACS = 'BACS';
export const PADS = 'PADS';
export const SEPA = 'SEPA';
export const KLARNA = 'KLARNA';
export const AFFIRM = 'AFFIRM';